import { enAuth, enCommon, enQuotes, enRecorder, enShell, enTeam, enTerms } from './en'
import { esAuth, esCommon, esQuotes, esRecorder, esShell, esTeam, esTerms } from './es'

export const resources = {
  en: {
    auth: enAuth,
    common: enCommon,
    quotes: enQuotes,
    recorder: enRecorder,
    shell: enShell,
    team: enTeam,
    terms: enTerms,
  },
  es: {
    auth: esAuth,
    common: esCommon,
    quotes: esQuotes,
    recorder: esRecorder,
    shell: esShell,
    team: esTeam,
    terms: esTerms,
  },
}
